export default __webpack_public_path__ + "static/tourist-traps-7-useful-tactics-and-how-to-avoid-them-taxi-426ba13c8f409c2df866fc97b3b27236.jpg";